{
  "tabs": {
    "chat": "Sohbet",
    "reminders": "Hatırlatıcılar",
    "calendar": "Takvim",
    "settings": "Ayarlar"
  },
  "common": {
    "cancel": "İptal",
    "save": "Kaydet",
    "confirm": "Onayla",
    "delete": "Sil",
    "back": "Geri",
    "close": "Kapat",
    "edit": "Düzenle",
    "search": "Ara",
    "all": "Tümü",
    "loading": "Yükleniyor...",
    "error": "Bir şeyler yanlış gitti",
    "notFound": "Bulunamadı",
    "tryAgain": "Lütfen tekrar deneyin",
    "retry": "Tekrar dene",
    "undo": "Geri al",
    "pullToRefresh": "Yenilemek için çek",
    "justNow": "az önce"
  },
  "auth": {
    "welcome": "FishMemory'e hoş geldiniz",
    "tagline": "WhatsApp hatırlatıcı asistanınız, şimdi cebinizde.",
    "subtitle": "WhatsApp hatırlatıcı asistanınız, şimdi cebinizde.",
    "phoneLabel": "WhatsApp numaranız",
    "phoneHint": "Doğrulama kodunu WhatsApp ile göndereceğiz",
    "invalidPhone": "Lütfen geçerli bir telefon numarası girin",
    "continue": "Devam et",
    "enterPhone": "WhatsApp numaranızı girin",
    "phonePlaceholder": "Telefon numarası",
    "sendCode": "Kodu Gönder",
    "verifyTitle": "Numaranızı doğrulayın",
    "otpSentTo": "{{phone}} numarasına WhatsApp ile 6 haneli kod gönderildi",
    "enterFullCode": "Lütfen tüm 6 haneyi girin",
    "invalidOtp": "Geçersiz kod. Lütfen tekrar deneyin.",
    "otpFailed": "Kod gönderilemedi. Tekrar deneyin.",
    "otpResent": "Kod tekrar gönderildi",
    "resendIn": "{{seconds}}sn içinde tekrar gönder",
    "resendCode": "Kodu tekrar gönder",
    "enterOtp": "WhatsApp'a gönderilen kodu girin",
    "verify": "Doğrula",
    "resend": "Kodu tekrar gönder",
    "wrongNumber": "Yanlış numara mı?",
    "backToPhone": "Telefona dön",
    "editPhone": "Telefon numarasını düzenle",
    "error": "Hata",
    "setupTitle": "Hadi ayarlayalım",
    "setupSubtitle": "Bunları Ayarlar'dan her zaman değiştirebilirsiniz",
    "namePlaceholder": "Adınız",
    "letsGo": "Kurulumu tamamla",
    "skipForNow": "Şimdilik atla"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Mesaj yaz...",
    "inputPlaceholder": "Mesaj yaz...",
    "typing": "FishMemory yazıyor...",
    "online": "Çevrimiçi",
    "connecting": "Bağlanıyor...",
    "reconnecting": "Yeniden bağlanıyor...",
    "offline": "Çevrimdışı",
    "empty": "Sohbete başla",
    "emptyHint": "Hatırlatıcı oluştur, takvimini kontrol et veya yardım iste.",
    "emptyAction": "Örnek hatırlatıcı gönder",
    "actions": "Sohbet işlemleri",
    "keep": "Mesajları sakla",
    "clearTitle": "Sohbeti temizle",
    "clearConfirm": "Bu cihazdaki tüm mesajlar silinsin mi? Bu işlem geri alınamaz.",
    "clear": "Sohbeti temizle",
    "optionSelected": "Seçildi: {{label}}",
    "sendingSelection": "Gönderiliyor...",
    "connectionLost": "Yeniden bağlanıyor..."
  },
  "reminders": {
    "title": "Hatırlatıcılarım",
    "active": "Aktif",
    "today": "Bugün",
    "thisWeek": "Bu Hafta",
    "history": "Geçmiş",
    "items": "öğe",
    "emptyTitle": "Henüz hatırlatıcı yok",
    "emptySubtitle": "Sohbetten bir tane oluşturun, burada görünecek.",
    "emptyAction": "Sohbeti aç",
    "filterActive": "Aktif",
    "filterToday": "Bugün",
    "filterWeek": "Bu Hafta",
    "filterHistory": "Geçmiş",
    "emptyState": "Henüz hatırlatıcı yok. Sohbete başla!",
    "swipeDone": "Tamamlandı",
    "swipeSnooze": "Ertele",
    "swipeDelete": "Sil",
    "search": "Hatırlatıcı ara...",
    "upcoming": "Yaklaşan",
    "completed": "Tamamlanan",
    "overdue": "Gecikmiş",
    "tomorrow": "Yarın",
    "synced": "Eşitlendi {{value}}",
    "swipeHint": "Daha fazla işlem için hatırlatıcıyı kaydır",
    "noResults": "Aramanızla eşleşen hatırlatıcı yok",
    "noResultsHint": "Farklı bir anahtar kelime deneyin veya aramayı temizleyin",
    "deleteAllFailed": "Tüm hatırlatıcılar silinemedi"
  },
  "calendar": {
    "title": "Takvim",
    "today": "Bugün",
    "tomorrow": "Yarın",
    "completed": "tamamlandı",
    "noEvents": "Planlanmış etkinlik yok",
    "noEventsSubtitle": "Hatırlatıcıları ve takvim etkinliklerini görmek için bir tarih seçin.",
    "googleEvent": "Google Takvim",
    "legendActive": "Aktif",
    "legendRecurring": "Tekrarlayan",
    "legendDone": "Tamamlandı",
    "legendGoogle": "Google",
    "previousMonth": "Önceki ay",
    "nextMonth": "Sonraki ay",
    "previousYear": "Önceki yıl",
    "nextYear": "Sonraki yıl",
    "goToToday": "Bugüne git",
    "all": "Tümü",
    "active": "Aktif",
    "done": "Tamamlandı",
    "paused": "Duraklatıldı"
  },
  "settings": {
    "title": "Ayarlar",
    "profile": "Profil",
    "name": "Görünen Ad",
    "enterName": "Adınızı girin",
    "language": "Dil",
    "uiLanguage": "Uygulama dili",
    "uiLanguageHelp": "Sadece bu cihazda uygulama arayüzü, takvim etiketleri ve düzen yönünü değiştirir.",
    "serverLanguage": "Sohbet dili",
    "serverLanguageHelp": "Hesabınız için sunucu yanıtları ve hatırlatıcı mesajlarında kullanılan dili değiştirir.",
    "timezone": "Saat dilimi",
    "currentTimezone": "Mevcut saat dilimi",
    "timezoneHelp": "Tüm hatırlatıcı saatleri bu saat dilimine göre gösterilir.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Saat dilimini kaydet",
    "timezoneSaved": "Saat dilimi güncellendi",
    "detect": "Algıla",
    "detectFailed": "Saat dilimi algılanamadı",
    "autoDetect": "GPS'den otomatik algıla",
    "notifications": "Bildirimler",
    "notificationsHelp": "Takip hatırlatıcıları, bir hatırlatıcı teslim edildikten sonra tekrar uyarıları kontrol eder. Cihaz düzeyindeki bildirim izinleri telefon ayarlarınızda yönetilir.",
    "pushEnabled": "Push Bildirimleri",
    "autoDoneOnFire": "Çalıştığında otomatik tamamla",
    "autoDoneOnFireDesc": "Kapalıysa, hatırlatıcılar siz tamamlayana kadar aktif kalır.",
    "googleCalendar": "Google Takvim",
    "google": "Google Takvim",
    "googleConnected": "Bağlı",
    "googleDisconnected": "Bağlı değil",
    "googleConnectedHelp": "Yeni hatırlatıcılar takviminize otomatik senkronize edilebilir.",
    "googleDisconnectedHelp": "Hatırlatıcılar ve etkinliklerin uyumlu kalması için Google Takvim'i bağlayın.",
    "googleConnectFailed": "Google Takvim bağlanamadı",
    "connected": "Bağlı",
    "disconnected": "Bağlı değil",
    "connect": "Bağlan",
    "disconnect": "Bağlantıyı kes",
    "autoSync": "Yeni hatırlatıcıları otomatik senkronize et",
    "autosync": "Yeni hatırlatıcıları otomatik senkronize et",
    "subscription": "Abonelik",
    "trialUsed": "Deneme: {{used}}/{{total}} kullanıldı",
    "trialStatus": "Deneme mevcut",
    "activeStatus": "Aktif abonelik",
    "expiredStatus": "Abonelik süresi doldu",
    "unsubscribedStatus": "Abone değil",
    "about": "Hakkında",
    "version": "Sürüm",
    "logout": "Çıkış Yap",
    "logoutTitle": "Çıkış Yap",
    "logoutConfirm": "Çıkış yapmak istediğinizden emin misiniz?",
    "noName": "İsim ayarlanmadı",
    "serverConnection": "Sunucu bağlantısı",
    "serverUrl": "Sunucu URL'si",
    "serverEdit": "Düzenle",
    "saveReconnect": "Kaydet ve yeniden bağlan",
    "resetDefault": "Varsayılanı sıfırla",
    "invalidServerUrlTitle": "Geçersiz sunucu URL'si",
    "invalidServerUrlMessage": "Geçerli bir http veya https sunucu URL'si girin, örneğin https://example.com",
    "uiLanguageChangeFailed": "Uygulama dili değiştirilemedi. Lütfen tekrar deneyin.",
    "serverLanguageChangeFailed": "Sohbet dili değiştirilemedi. Lütfen tekrar deneyin.",
    "timezoneChangeFailed": "Saat dilimi değiştirilemedi. Lütfen tekrar deneyin.",
    "autoSyncChangeFailed": "Otomatik senkronizasyon güncellenemedi. Lütfen tekrar deneyin.",
    "nameChangeFailed": "Görünen ad güncellenemedi. Lütfen tekrar deneyin.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Hatırlatıcı detayları",
    "editTime": "Zamanı düzenle",
    "rename": "Yeniden adlandır",
    "snooze": "Ertele",
    "snooze15": "15 dakika ertele",
    "pause": "Duraklat",
    "pauseReminder": "Hatırlatıcıyı duraklat",
    "resume": "Devam et",
    "resumeReminder": "Hatırlatıcıyı devam ettir",
    "skip": "Sonrakini atla",
    "skipOccurrence": "Bu tekrarı atla",
    "syncGoogle": "Google ile senkronize et",
    "delete": "Sil",
    "deleteTitle": "Hatırlatıcıyı sil",
    "deleteConfirm": "Bu hatırlatıcı kalıcı olarak silinecek.",
    "deleteRecurringTitle": "Tekrarlayan hatırlatıcıyı sil",
    "deleteRecurringMessage": "Bu tekrarı atlamak mı yoksa tüm seriyi silmek mi istiyorsunuz?",
    "deleteThisOccurrence": "Bu tekrarı atla",
    "deleteEntireSeries": "Tüm seriyi sil",
    "done": "Tamamlandı",
    "markDone": "Tamamlandı olarak işaretle",
    "undo": "Geri al",
    "undoPrompt": "Tekrar aktif olması mı gerekiyor? Şimdi geri yükle.",
    "recurring": "Tekrarlayan",
    "nextRun": "Sonraki çalışma",
    "oneTime": "Tek seferlik",
    "pending": "Beklemede",
    "sent": "Gönderildi",
    "paused": "Duraklatıldı",
    "active": "Aktif",
    "snoozed": "Erteleme yapıldı",
    "localTime": "Yerel saatinizde gösterilir",
    "recurrence": "Tekrarlama",
    "created": "Oluşturuldu",
    "tags": "Etiketler",
    "fireCount": "Çalışma sayısı",
    "actions": "İşlemler",
    "none": "Yok",
    "snoozeFailed": "Hatırlatıcı ertelenemedi",
    "pauseFailed": "Hatırlatıcı duraklatılamadı",
    "resumeFailed": "Hatırlatıcı devam ettirilemedi",
    "skipFailed": "Hatırlatıcı atlanamadı",
    "doneFailed": "Hatırlatıcı tamamlandı olarak işaretlenemedi",
    "undoFailed": "Hatırlatıcı durumu geri yüklenemedi",
    "deleteFailed": "Hatırlatıcı silinemedi",
    "rescheduleTitle": "Yeniden planlansın mı?",
    "rescheduleMsg": "Bu hatırlatıcı süresi geçti. Yeniden planlamak ister misiniz?",
    "reschedule15": "15 dakika içinde",
    "reschedule60": "1 saat içinde",
    "keepOverdue": "Olduğu gibi bırak"
  },
  "onboarding": {
    "slide1Title": "FishMemory'e hoş geldiniz",
    "slide1Sub": "Kişisel hatırlatıcı asistanınız — WhatsApp destekli ve cebiniz için tasarlandı.",
    "slide2Title": "Doğal Sohbet Edin",
    "slide2Sub": "Hatırlatıcıları düşündüğünüz gibi yazın: \"Yarın saat 3'te anneyi aramamı hatırlat\" — gerisini biz hallederiz.",
    "slide3Title": "Hiçbir Şeyi Kaçırmayın",
    "slide3Sub": "Zamanında bildirim alın, etiketlerle organize olun ve önemli her şeyin üstünde kalın.",
    "getStarted": "Başlayalım",
    "next": "İleri",
    "firstReminderTitle": "İlk hatırlatıcınızı oluşturun!",
    "firstReminderHint": "Şöyle bir şey yazmayı deneyin:",
    "firstReminderExample": "Yarın saat 9'da su içmeyi hatırlat",
    "gotIt": "Anladım!",
    "notifRationaleTitle": "Zamanında kalın",
    "notifRationaleBody": "FishMemory, sizi zamanında hatırlatmak için bildirimlere ihtiyaç duyar. Sadece oluşturduğunuz hatırlatıcılar için uyarı alırsınız.",
    "notifRationaleAllow": "Bildirimleri Aç",
    "notifRationaleLater": "Belki sonra",
    "swipeHint": "Hızlı işlemler için sağa kaydır →",
    "calendarDragHint": "Genişletmek için sürükle ↕"
  }
}
